import { render, staticRenderFns } from "./PopUpMessage.vue?vue&type=template&id=f974b1aa&scoped=true"
import script from "./PopUpMessage.vue?vue&type=script&lang=js"
export * from "./PopUpMessage.vue?vue&type=script&lang=js"
import style0 from "./PopUpMessage.vue?vue&type=style&index=0&id=f974b1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f974b1aa",
  null
  
)

export default component.exports